<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex v-bind="{ [titleBoxSize]: titleBoxSize !== '' }" class="d-flex align-center justify-center text-md-left">
        <span :class="titleClass">
          {{ title }}
        </span>
      </v-flex>
      <v-flex v-bind="{ [boxSize]: boxSize !== '' }" class="text-md-right">
        <v-layout row wrap class="justify-end">
          <slot name="content">
          </slot>
          <v-flex v-bind="{ [dateTypeBoxSize]: hasDateType }" v-if="date && hasDateType">
            <v-select
              solo
              label="Periodo"
              color="grey"
              :items="types"
              v-model="filters.dateType"
              @input="changeDateType">
            </v-select>
          </v-flex>
          <v-flex v-bind="{ [dateBoxSize]: true }" :xs4="!hasDateType" v-if="date">
            <v-menu
              lazy
              offset-y
              full-width
              transition="scale-transition"
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="dateMenu">
              <v-text-field
                solo
                readonly
                slot="activator"
                class="k-orange-linear-text"
                prepend-icon="event"
                :value="formatDate">
              </v-text-field>
              <v-date-picker
                locale="es"
                color="k-orange-linear"
                :key="`datepicker-${filters.dateType}`"
                :type="filters.dateType"
                v-model="filters.date"
                @change="changePicker">
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex v-bind="{ [companyLoadBoxSize]: hasCompanyLoad }" v-if="hasCompanyLoad">
            <company-load-filter @search="$emit('search')" :filters="filters"></company-load-filter>
          </v-flex>
          <v-flex shrink v-if="hasChannel">
            <v-select
              solo
              color="grey"
              label="Canales"
              item-text="channel"
              item-value="id"
              :items="channels"
              v-model="filters.channel"
              @input="searchData">
              <template slot="selection" slot-scope="data">
                <div class="input-group__selections__comma" v-if="data.item.id !== 0">
                  {{ showNameChannel(data.item.id) }}
                </div>
                <div class="input-group__selections__comma" v-else>
                  {{ data.item.channel }}
                </div>
              </template>
              <template slot="item" slot-scope="data">
                <span  v-if="data.item.id !== 0">
                  {{ showNameChannel(data.item.id) }}
                </span>
                <span v-else>
                  {{ data.item.channel }}
                </span>
              </template>
            </v-select>
          </v-flex>
          <v-flex v-bind="{ [btnFilterSize]: true }" v-if="filtersButton">
            <v-btn
              :color="filterBtnColor"
              class="h-100 ma-0 w-100 btn-filter"
              @click="modal = true">
              <v-icon>filter_list</v-icon>
              Filtrar
            </v-btn>
          </v-flex>
          <slot name="downloadButton">
          </slot>
        </v-layout>
      </v-flex>
    </v-layout>
    <filter-modal
      :show="modal"
      :custom-filters="customFilters"
      :deafult-filters="filters"
      @close="modal = false"
      @filter="applyFilters"
      @removeFilter="removeFilter">
    </filter-modal>
  </v-container>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import ChannelMixin from '@/mixins/channels';
import FilterModal from '@/components/global/FilterModal';
import CompanyLoadFilter from '@/components/global/CompanyLoadFilter';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    boxSize: {
      type: String,
      default: '',
    },
    companyLoadBoxSize: {
      type: String,
      default: 'md3',
    },
    titleBoxSize: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: 'title',
    },
    customFilters: {
      type: Array,
      default: () => [],
    },
    filtersButton: {
      type: Boolean,
      default: true,
    },
    filters: {
      type: Object,
      default: () => {},
    },
    date: {
      type: Boolean,
      default: true,
    },
    hasDateType: {
      type: Boolean,
      default: true,
    },
    hasCompanyLoad: {
      type: Boolean,
      default: false,
    },
    hasChannel: {
      type: Boolean,
      default: false,
    },
    hasAllChannels: {
      type: Boolean,
      default: false,
    },
    btnFilterSize: {
      type: String,
      default: 'xs2',
    },
    dateBoxSize: {
      type: String,
      default: 'xs3',
    },
    dateTypeBoxSize: {
      type: String,
      default: 'xs3',
    },
  },
  mixins: [
    ChannelMixin,
  ],
  components: {
    FilterModal,
    CompanyLoadFilter,
  },
  data() {
    return {
      dateMenu: false,
      modal: false,
      types: [
        {
          text: 'Diario',
          value: 'date',
        },
        {
          text: 'Mensual',
          value: 'month',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      dimention: 'dimentions',
      channelsAll: 'channels',
    }),
    formatDate() {
      let format = 'DD/MM/YYYY';
      if (this.filters.dateType === 'month') {
        format = 'MM/YYYY';
      }
      return moment(this.filters.date).format(format);
    },
    channels() {
      const channels = [
        ...this.channelsAll.filter(x => !x.channel.includes('in')),
      ];
      if (this.hasAllChannels) {
        const obj = {
          id: 0,
          channel: 'Todos',
        };
        channels.unshift(obj);
      }
      return channels;
    },
    filterBtnColor() {
      const filters = [
        'type',
        'agent',
        'state',
        'gender',
        'status',
        'agency',
        'tranche',
        'due_day',
        'age_group',
        'last_name',
        'dimention',
        'first_name',
        'ns_stage_id',
        'account_type',
        'trancheStatus',
        'portfolio_type',
        'customer_status',
        'workflow_status',
        'last_n_channel_id',
        'last_r_channel_id',
        'last_c_channel_id',
      ];
      const dim = this.dimention.map(item => item.name);
      filters.push(...dim);
      return Object.keys(this.filters).filter(item => filters.includes(item)).length > 0 ? 'k-orange-linear' : 'default';
    },
  },
  methods: {
    applyFilters($event) {
      this.searchData($event);
    },
    changePicker() {
      this.dateMenu = false;
      this.searchData();
    },
    searchData($event) {
      this.modal = false;
      const filters = {
        ...this.filters,
        ...$event,
      };
      if (!this.date) {
        delete filters.date;
        delete filters.dateType;
      }
      if (filters.dateType === 'month') {
        filters.date = filters.date.substr(0, 7);
      }
      this.$emit('search', filters);
    },
    changeDateType() {
      if (this.filters.dateType === 'month') {
        this.filters.date = moment().format('YYYY-MM');
      } else {
        this.filters.date = moment().format('YYYY-MM-DD');
      }
      this.searchData();
    },
    removeFilter($event) {
      if (Object.prototype.hasOwnProperty.call(this.filters, $event)) {
        delete this.filters[$event];
      }
    },
  },
};
</script>
<style scoped>
  .btn-filter >>> .btn__content{
    height: 46px;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/FiltersBar.vue